import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { useLockedOrders } from '@hooks/useLockedOrders'
import api from '@utils/api'
import { Drawer, Spin, Table } from 'antd'
import { useEffect, useState } from 'react'

import { getDefaultColumns } from './_defaultColumns'

export function OrderDrawer({ triggerModal, orderPreviewStoreId, closeOrderDrawer }) {
  const [previewOrders, setPreviewOrders] = useState()
  const [loading, setLoading] = useState(true)
  const { scopes } = useSecurityContext()
  const canReadOrderScope = scopes?.scopes?.includes('o.r')
  const canViewOrderDrawer = scopes?.createOrder || canReadOrderScope
  const { lockedOrders } = useLockedOrders()

  useEffect(() => {
    if (orderPreviewStoreId) {
      setLoading(true)
      api.getOrderByStore(orderPreviewStoreId).then(({ data }) => {
        setLoading(false)
        setPreviewOrders(data)
      })
    }
  }, [orderPreviewStoreId])

  const updateOrder = (order) => {
    const index = previewOrders?.findIndex((o) => o.id === order.id)
    const copy = [...previewOrders]
    copy[index] = order
    setPreviewOrders(copy)
  }
  if (!canViewOrderDrawer) return null

  return (
    <Drawer
      title='Site Orders'
      placement='bottom'
      closable
      onClose={() => {
        setPreviewOrders([])
        closeOrderDrawer()
      }}
      open={!!orderPreviewStoreId}
      key='bottom'
      height={previewOrders ? previewOrders.length * 60 + 220 : 220}
    >
      {loading ? (
        <div className='center-flex-container p-5'>
          <Spin />
        </div>
      ) : (
        <Table
          rowClassName={(row) => {
            const match = lockedOrders.find((o) => o.order_id === row.id)
            if (match?.state === 'pending') {
              return 'site-orders pending-row'
            }
            return ''
          }}
          rowKey='id'
          dataSource={previewOrders ?? []}
          columns={getDefaultColumns(triggerModal, updateOrder, lockedOrders)}
          showHeader
          pagination={false}
          scroll={{ y: previewOrders ? previewOrders.length * 130 : 200 }}
        />
      )}
    </Drawer>
  )
}
